import * as r from "../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
const b = (l = {}) => {
  const {
    inset: t = 0.4,
    softness: o = 0.5,
    offsetX: n = 0,
    offsetY: d = 0
  } = l, {
    float: s,
    smoothstep: c,
    uv: f
  } = r, a = f(), u = a.x.sub(0.5).sub(s(n)).mul(2), e = a.y.sub(0.5).add(s(d)).mul(2), m = u.mul(u).add(e.mul(e)).sqrt();
  return s(1).sub(c(
    s(1).sub(s(t)),
    s(1).sub(s(t)).add(s(o)),
    m.mul(s(1).add(s(o)))
  ));
};
export {
  b as default,
  b as edgeMask
};
